import { ReduxStore } from 'store/types';

function archiveThreadMessageIsLoading(state: ReduxStore): boolean {
  return state.intervention.archiveThreadMessage.config.isLoading;
}

export default archiveThreadMessageIsLoading;
